var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58579 6.5L0.292893 10.7929C-0.0976311 11.1834 -0.0976311 11.8166 0.292893 12.2071C0.683418 12.5976 1.31658 12.5976 1.70711 12.2071L6.70711 7.20711C7.09763 6.81658 7.09763 6.18342 6.70711 5.79289L1.70711 0.792893C1.31658 0.402369 0.683418 0.402369 0.292893 0.792893C-0.0976311 1.18342 -0.0976311 1.81658 0.292893 2.20711L4.58579 6.5Z",
    fill: "#3C7363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeCollapse);
export default __webpack_public_path__ + "static/media/Shape_collapse.06d280dcfec1fea6faeee3015dce11bd.svg";
export { ForwardRef as ReactComponent };